/**
 * Provides utility functions related to Amazon Store ID generation for JWO integration.
 *
 * @returns {{
 *   generateAmazonStoreId: (businessUnit: string, stationName: string, stationId: string) => string
 * }}
 */
export default () => {
  /**
   * Generates the Amazon Store ID.
   * Creates the ID in the format:
   * {Business Unit Number}-{Station Name first 10 characters}-{Station ID}
   *
   * @param {string} businessUnit - The business unit code
   * @param {string} stationName - The name of the station
   * @param {string} stationId - The ID of the station
   * @returns {string} The generated Amazon Store ID
   */
  const generateAmazonStoreId = (
    businessUnit: string,
    stationName: string,
    stationId: string,
  ): string => {
    // Handle potential undefined values
    const sanitizedBusinessUnit = businessUnit || '';
    const sanitizedStationId = stationId || '';
    const stationNamePart = stationName ? stationName.substring(0, 10) : '';

    return `${sanitizedBusinessUnit}-${stationNamePart}-${sanitizedStationId}`;
  };

  return {
    generateAmazonStoreId,
  };
};
